<template>
  <div class="conversation-container">
    <div class="header d-flex">
      <div class="header-left">
        <div class="d-flex mb-4">
          <div class="title-tag">#</div>
          <div class="font-bold font-24 title">
            <div class="title-text">疫情当前，你认为税务考试对你延期有什么影响？</div>

            <div class="under-line"></div>
          </div>
        </div>

        <div class="text-color font-14 ">
          <span class="font-bold">
            导语：
          </span>
          这是一段帖子内容，这是一段帖子内容，这是一段帖子内容，这是一段帖子内容，这是一段
          帖子内容，这是一段帖子内容，这是一段帖子内容，这是一段帖子内容，这是一帖子内容
        </div>
        <div class="d-flex mt-10">
          <a-button
            class="mr-4"
            shape="round"
            type="primary"
            @click="replyContentShow=true"
          >
            回答
          </a-button>
          <div class="d-flex text-color mr-2">
            <img class="icon-img mr-1" :src="wenda" alt="">
            30
          </div>
          <div class="d-flex text-color mr-2">
            <img class="icon-img mr-1" :src="wenda" alt="">
            30
          </div>
          <div class="d-flex text-color mr-2">
            <img class="icon-img mr-1" :src="wenda" alt="">
            30
          </div>
        </div>
      </div>
      <img class="header-img" :src="wendaHeader" alt="">
    </div>
    <div class="content mt-3 mb-10">
      <div v-if="replyContentShow" class="reply-content pa-3 pb-4">
        <a-textarea v-model="postReplyContent" placeholder="请输入内容" :rows="7" ></a-textarea>
        <div class="d-flex justify-end mt-4">
          <a-button
            shape="round"
            type="primary"
            @click="PostReply"
          >
            回复
          </a-button>
        </div>
      </div>
      <div class="reply-content px-3 py-4 mt-3">
        <div class="font-bold font-16 mb-10">
          96个回答
        </div>
        <div class="list-content">
          <div class="d-flex align-stretch mb-4" v-for="(item,index) in 4" :key="index">
            <div class=" d-flex align-start mr-4">
              <div class="avatar">

              </div>
            </div>

            <div class="flex-1 font-16 pb-2 border-bottom">
              <div class="font-bold mb-3">13559475565</div>
              <div class="create-time font-14 mb-1">2020.12.17 19:00</div>
              <div class="mb-3">马老师团队不用多说了，这么多年的经验，当初最早看马老师视频入门的，逻辑思维各方面都很好，关键是课程是活的，项目驱动，并行学习，很喜欢
                马老师的两大教学理念，这些都是程序员学习进步非常重要的，时代在进步，高效的学习知识变得非常重要，希望大家都能一起进步！</div>
              <div class="reply-text-content ">
                <div class="text-cut-2">
                  <span class="text-color mr-1">回复</span><span class="font-bold mr-1">13559475565:</span><span class="text-color">
                    太赞了，马老师的规划真的很牛！马老师团队不用多说了，这么多年的经验，当初最早看马老师视频入门的，逻辑思维各方面都很好，关键是课程是活的，项目驱动，并行学习，很喜欢
                    马老师的两大教学理念，这些都是程序员学习进步非常重要的，时代在进步，高效的学习知识变得非常重要，希望大家都能一起进步！马老师团队不用多说了，这么多年的经验，当初最早看马老师视频入门的，逻辑思维各方面都很好，关键是课程是活的，项目驱动，并行学习，很喜欢
                    马老师的两大教学理念，这些都是程序员学习进步非常重要的，时代在进步，高效的学习知识变得非常重要，希望大家都能一起进步！
                  </span>
                </div>

              </div>
              <div class="d-flex mt-3">
                <a-button class="reply-btn" @click="modalShow" type="link">
                  回复
                </a-button>
                <a-popconfirm
                  title="你确定要删除这条内容吗？"
                  ok-text="确定"
                  cancel-text="取消"
                  @confirm="confirmDelete"
                >
                  <a-button type="link">
                    删除
                  </a-button>
                </a-popconfirm>
              </div>
            </div>
          </div>
          <div class="d-flex justify-center pt-2 pb-4">
            <a-pagination
              v-model="current"
              :total="total"
              show-less-items
              @change="pageChange"
            />
          </div>
        </div>
      </div>
    </div>
    <a-modal width="400px" v-model="visible" title="回复">
      <a-textarea v-model="messageReplyContent" :placeholder="placeholder" :rows="7" ></a-textarea>
      <div slot="footer" class="text-center my-3">
        <a-button style="width:90%" type="primary" shape="round" @click="hanldeReply">回复</a-button>
      </div>
    </a-modal>
  </div>
</template>

<script>
import wendaHeader from '@/assets/wenda_header.png'
import wenda from '@/assets/icons/wenda.png'
export default {
  props: {

  },
  data () {
    return {
      wendaHeader,
      wenda,
      current: 1,
      total: 100,
      visible: false,
      replyContentShow: false,
      placeholder: '回复',
      postReplyContent: '',
      messageReplyContent: ''
    }
  },
  components: {

  },
  computed: {

  },
  created () {

  },
  mounted () {

  },
  watch: {

  },
  methods: {
    confirmDelete() {

    },
    pageChange(page) {

    },
    PostReply() {
      if (!this.postReplyContent) {
        this.$message.warning('您还未输入回复内容')
      } else {
        this.$message.success('回复成功')
        this.postReplyContent = ''
      }
    },
    modalShow() {
        this.visible = true
    },
    hanldeReply() {
       if (!this.messageReplyContent) {
        this.$message.warning('请输入回复内容')
      } else {
        this.$message.success('回复成功')
        this.visible = false
        this.messageReplyContent = ''
      }
    }
  }
}
</script>

<style scoped lang="less">
::v-deep .ant-input{
  background-color: #F5F8FA;
  border:0;
  border-radius: 15px;
  resize: none
}
::v-deep .ant-modal-header{
  border-bottom:0
}
::v-deep .ant-modal-footer{
  border-top:0
}
::v-deep .ant-modal-body{
 padding-top: 0;
 padding-bottom: 0;;
}
.text-color{
  color:#5E668D;
}
.header{
height: 275px;
background: #EBEAFC;
padding:0 15%;
.header-img{
  width:330px;
}
.header-left{
  padding-right:115px;
}
.title-tag{
  color:#fff;
  font-size:22px ;
  width:25px;
  height:25px;
  border-radius: 50%;
  border-bottom-right-radius: 0;
  background-color:#1564FF ;
  text-align: center;
  line-height: 25px;
  margin-right: 10px;
}
.title{
  position:relative;
}
.title-text{
  position:relative;
  z-index:1;
}
.under-line{
height: 10px;
background: #00CBDE;
position:absolute;
width:100%;
bottom:5px;
}

.icon-img{
  width:15px;
  height:15px;
}
}
.content{
  padding:0 10%;
}
.reply-content{
  border-radius:15px ;
  background: #fff;
}
.list-content{
  .avatar{
    width:50px;
    height:50px;
    border-radius: 50%;
    overflow: hidden;
    background-color: red;
  }

  .reply-btn{
    padding-left: 0 !important;
  }
  .reply-text-content{
  background: #F9FAFC;
  border-radius: 5px;
  padding:10px 20px;
  position: relative;
  max-height:62px ;
  &::before{
    display: block;
    content:'';
    height:0;
    position: absolute;
    left:10px;
    top:-20px;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 10px solid transparent;
    border-bottom: 10px solid #F9FAFC;
  }
  }

}
</style>
